import gsap, { Power3 } from 'gsap'
import React, { useEffect, useRef } from 'react'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

const Gallery: React.FC = () => {
	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

		let ctx = gsap.context(() => {
			// let tl = gsap.timeline({})

			ScrollTrigger.create({
				trigger: '.gallery--main',
				start: 'top top',
				pin: '.gallery--nav',
				end: `bottom bottom`,
			})

			gsap.from('#gallery-main-one', {
				yPercent: -10,
				ease: 'none',
				scrollTrigger: {
					trigger: '#gallery-main-one',
					start: 'center center',
					scrub: 0.5,
					end: 'bottom 20%',
					// markers: true,
					toggleActions: 'play none none reverse',
					toggleClass: { targets: '#gallery-nav-one', className: 'gallery--nav-active' },
				},
			})

			gsap.to('#gallery-main-two', {
				yPercent: 15,
				ease: 'none',
				scrollTrigger: {
					trigger: '#gallery-main-two',
					start: 'top center',
					scrub: 0.5,
					end: 'bottom center',
					// markers: true,
					toggleActions: 'play none none reverse',
					toggleClass: { targets: '#gallery-nav-two', className: 'gallery--nav-active' },
				},
			})

			gsap.from('#gallery-main-three', {
				yPercent: 30,
				ease: 'none',
				scrollTrigger: {
					trigger: '#gallery-main-three',
					start: 'top center',
					scrub: 0.5,
					end: 'bottom center',
					// markers: true,
					toggleActions: 'play none none reverse',
					toggleClass: { targets: '#gallery-nav-three', className: 'gallery--nav-active' },
				},
			})

			gsap.to('#gallery-main-four', {
				yPercent: 10,
				ease: 'none',
				scrollTrigger: {
					trigger: '#gallery-main-four',
					start: 'top center',
					scrub: 0.5,
					end: 'bottom center',
					// markers: true,
					toggleActions: 'play none none reverse',
					toggleClass: { targets: '#gallery-nav-four', className: 'gallery--nav-active' },
				},
			})

			gsap.to('#gallery-main-five', {
				yPercent: 15,
				ease: 'none',
				scrollTrigger: {
					trigger: '#gallery-main-five',
					start: 'top center',
					scrub: 0.5,
					end: 'bottom center',
					// markers: true,
					toggleActions: 'play none none reverse',
					toggleClass: { targets: '#gallery-nav-five', className: 'gallery--nav-active' },
				},
			})

			// NAV
			document.querySelector('#gallery-nav-one')?.addEventListener('click', () => {
				gsap.to(window, { duration: 2, ease: Power3.easeInOut, scrollTo: { y: '#gallery-main-one', offsetY: 100 } })
			})

			document.querySelector('#gallery-nav-two')?.addEventListener('click', () => {
				gsap.to(window, { duration: 2, ease: Power3.easeInOut, scrollTo: { y: '#gallery-main-two', offsetY: 80 } })
			})

			document.querySelector('#gallery-nav-three')?.addEventListener('click', () => {
				gsap.to(window, { duration: 2, ease: Power3.easeInOut, scrollTo: { y: '#gallery-main-three', offsetY: 80 } })
			})

			document.querySelector('#gallery-nav-four')?.addEventListener('click', () => {
				gsap.to(window, { duration: 2, ease: Power3.easeInOut, scrollTo: { y: '#gallery-main-four', offsetY: 100 } })
			})

			document.querySelector('#gallery-nav-five')?.addEventListener('click', () => {
				gsap.to(window, { duration: 2, ease: Power3.easeInOut, scrollTo: { y: '#gallery-main-five', offsetY: 160 } })
			})
		})

		return () => ctx.revert()
	}, [])

	return (
		<div className='gallery--container'>
			<div className='gallery--main'>
				<img id='gallery-main-one' src='/images/gallery/gallery-one.png' alt='' />
				<img id='gallery-main-two' src='/images/gallery/gallery-two.png' alt='' />
				<img id='gallery-main-three' src='/images/gallery/gallery-three.png' alt='' />
				<img id='gallery-main-four' src='/images/gallery/gallery-four.png' alt='' />
				<img id='gallery-main-five' src='/images/gallery/gallery-five.png' alt='' />
			</div>

			<div className='gallery--nav'>
				<img id='gallery-nav-one' src='/images/gallery/gallery-one.png' alt='' />
				<img id='gallery-nav-two' src='/images/gallery/gallery-two.png' alt='' />
				<img id='gallery-nav-three' src='/images/gallery/gallery-three.png' alt='' />
				<img id='gallery-nav-four' src='/images/gallery/gallery-four.png' alt='' />
				<img id='gallery-nav-five' src='/images/gallery/gallery-five.png' alt='' />
			</div>
		</div>
	)
}

export default Gallery
